import * as React from 'react';
import { map, groupBy, maxBy, entries, omit, isArray, flatten, uniqBy } from 'lodash-es';
import { useScenarioUnConfigStoreContext } from '../contexts/ScenarioUnConfigStoreContext';
import { useUnConfigBootStoreContext } from '../contexts/UnConfigBootStoreContext';
import type { Store } from '../types/api';
import { scenarioMap } from '../consts/scenarioMap';
import { useStepName } from './useStepName';
import { useRegionName } from './useRegionName';
import { get } from 'lodash-es';
import { useMemo } from 'react';

// 根据basic, advanced 环节和当前stepName的scenario 判断有多少store需要配置
// 其中最多的region是什么， 还有那些region需要配置
export const useConfigStore = () => {
  const allStores = useUnConfigBootStoreContext();
  const { storeInfo } = useScenarioUnConfigStoreContext();
  const stepName = useStepName();
  const getRegionName = useRegionName();
  const scenario = scenarioMap[stepName]!;
  const stores = React.useMemo<Store[]>(() => {
    if (isArray(scenario)) {
      return uniqBy(flatten(scenario.map((s) => get(storeInfo, s, []))), 'storeId');
    }
    return get(storeInfo, scenario, []);
  }, [storeInfo, scenario]);
  const regionsMap = React.useMemo(() => groupBy(stores, 'region'), [stores]);
  const mostRegion = React.useMemo(
    () => maxBy(entries(regionsMap), ([, value]) => value.length) || [''],
    [regionsMap],
  );
  const otherRegion = React.useMemo(
    () => entries(omit(regionsMap, mostRegion?.[0])),
    [regionsMap, mostRegion],
  );
  const storeIncludesTiktok = useMemo(() => {
    return stores.some((store) => {
      return ['TIKTOK', 'TIKTOK_US'].includes(store.externalType);
    });
  }, [stores]);

  return {
    isAll: stores.length === allStores.length,
    stores,
    mostRegion,
    mostRegionName: getRegionName(mostRegion?.[0]),
    regionsMap,
    otherRegion,
    otherRegionName: getRegionName(map(otherRegion, 0)),
    otherRegionNameFull: getRegionName(map(otherRegion, 0), true),
    storeIncludesTiktok,
  } as const;
};
